import React, { useEffect, useState } from 'react';
import './dashboard.css'
import { useNavigate } from 'react-router-dom';
import { abbreviateNumberDouble, convertSecondsToHoursLive, convertText, formatHoursLogged, getLocalUserDataByKey, logMessage, verifyProjectAddition } from '../../utils/helpers.js';
import { LuRadar } from "react-icons/lu";
import { FaRegCirclePlay, FaRegCirclePause } from "react-icons/fa6";
import { IoDiamondSharp } from "react-icons/io5";
import { MdOutlineCancel, MdTimerOff } from "react-icons/md";
import { RxCountdownTimer } from "react-icons/rx";
import Header from '../../components/common/header.js';
import imagePaths from '../../assets/imagePaths.js';
import paths from '../../utils/constants.js';
import api from '../../api/api.js';
import { ApiResponse } from '../../models/ApiResponseModel.js';
import { DataModel } from '../../models/projectModel.js';
import { convertSecondsToHours } from '../../utils/helpers.js';
import { GiStack } from 'react-icons/gi';
import { HomeModel } from '../../models/HomeModel.js';

const HomeScreen = ({ startLoading, stopLoading }) => {
    const navigate = useNavigate();
    const [type, setType] = useState("ongoing");
    const [liveTimer, setLiveTimer] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(0);
    const [projectWarningId, setProjectWarningId] = useState("");
    const [search, setSearchKey] = useState("");
    const [noUItext, setNoUiText] = useState("");
    const [showWarningStartTimer, setShowWarningStartTimer] = useState(false);
    const [name, setName] = useState("");
    const [profilePicture, setProfilePicture] = useState(imagePaths.demo_profile);
    const [projectData, setProjectData] = useState(new DataModel({}));

    const handleTypeClick = async (type) => {
        setType(type);
    }

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token || token.length <= 0) {
            navigate(paths.AUTH_SCREEN);
        }else{
            const isVerified = localStorage.getItem('isVerified');
            if (isVerified !== 'true') {
                navigate(paths.MY_PROFILE+"?viewplans=true");
            }
        }
        
    }, [navigate]);

    useEffect(() => {
        logMessage(liveTimer)
        if (liveTimer !== 0) {
            const intervalId = setInterval(() => {
                setLiveTimer(liveTimer + 1)
            }, 1000);
            return () => clearInterval(intervalId);
        }
    }, [liveTimer]);

    const handleStartTimer = async (type, project_id) => {
        const isTimerRunning = projectData.projectList.some(entry => entry.timer_status === "started");
        if (isTimerRunning) {
          setProjectWarningId(project_id)
          setShowWarningStartTimer(true)
          return; 
        }else{
          handleTimer("start",project_id); 
        }  
    };

    const handleTimer = async (type, project_id) => {
        if (type == "stop") {
            stop_timer(project_id);
        } else {
            start_timer(project_id);
        }
        logMessage("handle timer clicked")
    }
    
    const start_timer = async (project_id) => {
        try {
            startLoading()
            const data = {
                "project_id": project_id
            };
            const response = await api.startTimer(data);
            const apiResponse = new ApiResponse(
                response.status,
                response.message
            );
            if (apiResponse.status === 1) {
                fetchProjects();
                stopLoading();
            } else {
                logMessage(apiResponse.message, 'alert');
            }
        } catch (error) {
            logMessage(error);
        } finally {
            stopLoading();
        }
    }
    const stop_timer = async (project_id) => {
        try {
            startLoading()
            const data = {
                "project_id": project_id
            };
            const response = await api.stopTimer(data);
            const apiResponse = new ApiResponse(
                response.status,
                response.message
            );
            if (apiResponse.status === 1) {
                fetchProjects()
                stopLoading();
            } else {
                logMessage(apiResponse.message, 'alert');
            }
        } catch (error) {
            logMessage(error);
        } finally {
            stopLoading();
        }
    }
    const openProjectDetail = (project_id) => {
        navigate(paths.PROJECT_DETAIL + "?project_id=" + project_id);
    }
    const handleChange = (e) => {
        setSearchKey(e.target.value);
    }
    const searchProducts = async () => {

        if (search !== "") {
            try {
                startLoading()
                const data = {
                    "search": search
                };
                const response = await api.searchProduct(data);
                const apiResponse = new ApiResponse(
                    response.status,
                    response.message
                );
                if (apiResponse.status === 1) {
                    setType("");
                    logMessage("project data before");
                    logMessage(response.data);
                    const projectModel = {
                        totalPages: 0,
                        currentPage: 1,
                        totalProjects: response.data.length,
                        hasNextPage: false,
                        projects: response.data
                    }
                    const projectData = new DataModel(projectModel);
                    logMessage("project data before");
                    logMessage(projectData);
                    // logMessage(projectData);
                    setProjectData(projectData)
                    stopLoading();
                } else {
                    logMessage(apiResponse.message, 'alert');
                }
            } catch (error) {
                logMessage(error);
            } finally {
                stopLoading();
            }
        }
    }
    const fetchProjects = async () => {
        setNoUiText("")
        // const email = getLocalUserDataByKey("user_email");
        setName(getLocalUserDataByKey("user_name"));
        logMessage(getLocalUserDataByKey("user_name"))
        if(getLocalUserDataByKey("profile_picture") != ""){
            setProfilePicture(getLocalUserDataByKey("profile_picture"));
        }
       
        setProjectData(new DataModel({}))
        try {            
            startLoading()
            // const data = {
            //     "type": type,
            //     "page": page,
            //     "limit": limit
            // };
            const response = await api.getHomeScreenData();
            const apiResponse = new ApiResponse(
                response.status,
                response.message
            );
            if (apiResponse.status === 1) {
                logMessage(response.data);
                const projectData = new HomeModel(response.data);
                setProjectData(projectData)
                await stopLoading();
                setNoUiText("Currently, you don't have any projects in progress.")
                const updatedProjects = projectData.projectList.map(project => {
                    if (project.timer_status === "started") {
                        setLiveTimer(project.totalDuration)
                    }
                });

            } else {
                logMessage(apiResponse.message, 'alert');
            }
        } catch (error) {
            logMessage(error);
        } finally {
            stopLoading();
        }
    };
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token || token.length <= 0) {
            navigate(paths.AUTH_SCREEN);
        }else{
        if (type !== "") {
            fetchProjects();
        }
    }
    }, [type]);
    return (
        <div className='full_page_inner'>
            <Header />
            <div className='dashboard_container' style={{ backgroundImage: `url(${imagePaths.dashboard_background})` }}>
                <div className="home_container">
                {showWarningStartTimer && (
            <div className="popup-overlay">
              <div className="popup planspopup">
                <div
                 style={{ borderRadius: "8px", backgroundImage: `url(${imagePaths.viewplans})`, justifyContent: "center", display:"flex", alignItems:"center" }}
                >
                 
                   <img
                    style={{ width:"32px", height:"32px", marginRight:"8px" }}
                        className="premium_icon_inside"
                        src={imagePaths.premium}
                      />
                       
                  <p>Warning</p>
                  <p style={{ paddingTop:"5px" , marginLeft:"15px", cursor:"pointer" }} ><MdOutlineCancel style={{width:"20px", height:"20px"}} onClick={() => {
                  setShowWarningStartTimer(false);
                }} />
                  </p>
                </div>
                {/* <div className="redBackPlan">
                  <p>
                  Unable to add more than 5 project?
                  </p>
                  </div> */}
                  <p
                    style={{padding:"2px", fontSize:"14px"}}
                  >
                 Another timer is already running and will be paused if you start a new timer
                  </p>     
               
                <button className="delete-button viewplans-button" onClick={() => {
                  handleTimer("start", projectWarningId)
                  setShowWarningStartTimer(false);
                }} >
                Confirm
                </button>
                <button
                style={{marginTop:"1px", marginBottom:"3px"}}
                  className="cancel-button canceldelacc"
                  onClick={() => setShowWarningStartTimer(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
                    <div className='home_banner'>
                        <div className='grids grid_one'  style={{ backgroundImage: `url(${imagePaths.profilebackgrid})` }}>
                            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }} >
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                                    <img className="grid_one_avatar" src={profilePicture} alt="profile" />
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <span className='welcome'>Welcome,</span>
                                        <span className='home_name'>{name}</span>
                                    </div>
                                </div >
                                {(() => {
                                    const gamification = projectData?.gamification ?? null;
                                    const level = Number.isFinite(gamification?.level) ? gamification.level : 0;
                                    const levelTitle = gamification?.level_title ?? '';
                                    const totalXp = Number.isFinite(gamification?.total_xp) ? gamification.total_xp : 0;
                                    const currentXp = Number.isFinite(gamification?.current_xp)
                                        ? gamification.current_xp
                                        : 0;
                                    const xpRequired = Number.isFinite(gamification?.xp_required_for_completion)
                                        ? gamification.xp_required_for_completion
                                        : 0;

                                    const progressPct =
                                        xpRequired > 0
                                            ? Math.min((currentXp / xpRequired) * 100, 100)
                                            : 0;

                                    const streakDays = gamification?.streak_days ?? null;

                                    return (
                                    <div
                                        style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '8px', width: '100%' }}
                                        className='cursor-pointer redirect-to-your-progress'
                                        onClick={() => navigate(paths.YOUR_PROGRESS)}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <span style={{ display: 'inline-block',  color: '#552F83', fontSize: '14px', fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '70%' }}>
                                              Level {level}:{levelTitle ? `   ${levelTitle}` : ''}
                                            </span>
                                            <span style={{ fontSize: '12px', fontWeight: 500, color: '#323232', whiteSpace: 'nowrap' }}>
                                                {currentXp}/{xpRequired || totalXp} Points
                                            </span>
                                        </div>
                                        
                                        <div style={{ height: '5px', width: '100%', borderRadius: '3px', backgroundColor: 'rgba(72, 27, 111, 0.15)', overflow: 'hidden' }}>
                                            <div style={{
                                                height: '100%',
                                                borderRadius: '3px',
                                                background: 'linear-gradient(182.35deg, #512B80 -57.18%, #A33B89 91.87%)',
                                                transition: 'width 0.4s ease',
                                                width: `${progressPct}%`
                                            }}></div>
                                        </div>
                                        {streakDays && (
                                            <span style={{ display: 'inline-flex', alignItems: 'center', alignSelf: 'flex-start', fontSize: '10px', fontWeight: 500, padding: '3px 10px', borderRadius: '12px', color: '#323232', backgroundColor: '#FFD964', marginTop: '2px' }}>
                                       {String(streakDays).trim() ? streakDays : 'No streaks yet'}
                                            </span>
                                        )}
                                    </div>
                                    );
                                })()}
                            </div>
                        </div>
                        <div className='grids grid_inner grid_two' style={{ backgroundImage: `url(${imagePaths.grid_two})` }}>
                            <div className="left_inner_grid">
                                <RxCountdownTimer />
                            </div>
                            <div className="right_inner_grid">
                                <span className='numberingText'>{projectData.hoursLogged ? formatHoursLogged(projectData.hoursLogged):0 }</span><br></br>
                                <span className='numberingName'>Hours Logged</span>
                            </div>
                        </div>
                        <div className='grids grid_inner grid_three' style={{ backgroundImage: `url(${imagePaths.grid_three})` }}>
                            <div className="left_inner_grid">
                                <IoDiamondSharp />
                            </div>
                            <div className="right_inner_grid">
                                <span className='numberingText'>{projectData.diamondsPlaced ? abbreviateNumberDouble(projectData.diamondsPlaced):0 }</span><br></br>
                                <span className='numberingName'>Diamonds Placed</span>
                            </div>
                        </div>
                        <div className='grids grid_inner grid_four' style={{ backgroundImage: `url(${imagePaths.grid_four})` }}>
                            <div className="left_inner_grid">
                                <GiStack />
                            </div>
                            <div className="right_inner_grid">
                                <span className='numberingText'>{projectData.totalCompleted ? projectData.totalCompleted:0 }</span><br></br>
                                <span className='numberingName'>Projects Completed</span>
                            </div>
                        </div>
                        <div className='grids grid_inner grid_five' style={{ backgroundImage: `url(${imagePaths.grid_five})` }}>
                            <div className="left_inner_grid">
                                <MdTimerOff />
                            </div>
                            <div className="right_inner_grid">
                                <span className='numberingText'>{projectData.projectsNotStarted ? projectData.projectsNotStarted:0 }</span><br></br>
                                <span className='numberingName'>Projects not started</span>
                            </div>
                        </div>
                    </div>
                    <div className='inner_container'>
                        <div className='table_container home_container_table'>
                            <h4 className='table_title'>Current Projects</h4>
                            <div className='table_inner_card hometable'>
                                {projectData.projectList && projectData.projectList.length > 0 ? (
                                    <table>
                                        <thead>
                                            <tr>
                                                <th style={{ visibility: "hidden"}}>Image</th>
                                                <th>Design</th>
                                                <th>Artist</th>
                                                <th>Brand</th>
                                                <th>Logged time</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {projectData.projectList.length > 0 ? (
                                                projectData.projectList.map(project => (
                                                    <tr key={project._id} onClick={() => openProjectDetail(project._id)}>
                                                        <td><img alt="project_image" className="table_image" src={project.image[0]}></img></td>
                                                        <td className='design_text'>{project.design}</td>
                                                        <td>© {project.artist}</td>
                                                        <td>{project.brand}</td>
                                                        <td className='timesection'> {project && (
                                                            <>
                                                                {project.timer_status === "started" ? (
                                                                    <>
                                                                        <FaRegCirclePause
                                                                            className="timer_duration"
                                                                            onClick={(event) => {
                                                                                event.stopPropagation();
                                                                                handleTimer("stop", project._id);
                                                                            }}
                                                                        />
                                                                        {convertSecondsToHoursLive(liveTimer)}
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <FaRegCirclePlay
                                                                            className="timer_duration"
                                                                            onClick={(event) => {
                                                                                event.stopPropagation();
                                                                                // handleTimer("start", project._id);
                                                                                handleStartTimer("start", project._id);
                                                                            }}
                                                                        />
                                                                        {convertSecondsToHours(project.totalDuration)}
                                                                    </>
                                                                )}
                                                            </>
                                                        )} </td>
                                                        <td className='statusProject'><span className={project.project_status}> <LuRadar /> {convertText(project.project_status)}</span></td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <div className="no_project">
                                                {/* {showUI && ( */}
                                                  <div>
                                                   <p>
                                                   {noUItext}
                                                    </p> 
                                               </div>
                                                {/* )} */}
                                              </div>
                                            )}

                                        </tbody>
                                    </table>
                                ) : (
                                    <div className="no_project">
                                    {/* {showUI && ( */}
                                      <div>
                                       <p>
                                      {noUItext}
                                        </p> 
                                   </div>
                                    {/* )} */}
                                  </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomeScreen;